<template>
  <el-container class="content">
    <el-header style="height: 47px;">
      <Header></Header>
    </el-header>
    <el-container>
      <el-aside id="left" :style="asideStyle">
        <el-row>
         
          <el-col :span="left2">
            <!-- hiddenMenu-->
            <div v-show="showmenu" id="hiddenMenu">
              <div v-show="!isShowOnline">
                <el-menu default-active="/home,主页" class="el-menu-vertical-demo" @select="handleSelect"
                         style="height:100vh;">
                  <el-menu-item index="/home,主页">
                    <template slot="title">
                      <i class="el-icon-s-home" style="font-size: 23px;color: #2180d1"></i>
                      <span>我的主页</span>
                    </template>
                  </el-menu-item>

                  <el-submenu v-for="(menu1, index1) in menuListFirst" :key="index1" :index="menu1.id.toString()">
                    <template slot="title">
                      <i :class="menu1.icon" style="font-size: 23px;color: #2180d1"
                         v-if="'el-icon-s-comment' != menu1.icon && 'el-icon-s-order' != menu1.icon && 'el-icon-s-cooperation' != menu1.icon"></i>
                      <i :class="menu1.icon" style="font-size: 23px;color: #5cb87a"
                         v-if="'el-icon-s-cooperation' == menu1.icon"></i>
                      <i :class="menu1.icon" style="font-size: 23px;color: #e6a23c"
                         v-if="'el-icon-s-comment' == menu1.icon"></i>
                      <i :class="menu1.icon" style="font-size: 23px;color: #f56c6c"
                         v-if="'el-icon-s-order' == menu1.icon"></i>
                      <span>{{menu1.name}}</span>
                    </template>
                    <el-menu-item v-if="menu2.parentId == menu1.id" v-for="(menu2, index2) in menuListSecond"
                                  :key="index2"
                                  :index="menu2.url + ',' + menu2.name">{{menu2.name}}
                    </el-menu-item>
                  </el-submenu>
                </el-menu>
              </div>

              <div v-show="isShowOnline">
                <el-scrollbar style="height:90vh;">
                  <el-tabs v-model="loginActive">
                    <el-tab-pane label="网站登录" name="weblogin">
                      <el-tree
                        :data="webLoginList"
                        :props="defaultProps"
                        :render-content="renderContent"
                        :default-expand-all="true"
                        node-key="value"
                        ref="tree_0"
                        @node-click="chatWith"
                      ></el-tree>
                    </el-tab-pane>
                    <el-tab-pane label="APP登录" name="applogin">
                      <el-tree
                        :data="appLoginList"
                        :props="defaultProps"
                        :render-content="renderContent"
                        :default-expand-all="true"
                        node-key="value"
                        ref="tree_1"
                        @node-click="chatWith"
                      ></el-tree>
                    </el-tab-pane>
                  </el-tabs>
                </el-scrollbar>
                <!-- <span style="color:#c1c1c1;font-size:14px;"><hr
                  style="display:inline-block;width:20px;vertical-align:middle;border:0.5px solid #c1c1c1;"> 在线人员 <hr
                  style="display:inline-block;width:20px;vertical-align:middle;border:0.5px solid #c1c1c1;"></span>
                 <el-tree
                  :data="webLoginList"
                  :props="defaultProps"
                  :render-content="renderContent"
                  :default-expand-all="true"
                  node-key="value"
                  ref="tree_0"
                  @node-click="chatWith"
                ></el-tree>-->
              </div>
            </div>
            <!-- hiddenMenu-->
          </el-col>
        </el-row>
      </el-aside>

      <el-main>
        <el-container>
          <!-- <el-aside style="width:9px;">
            <div style="height: 100vh;background-color: #eee;display: flex;justify-content: center;align-items: center">
              <div class="Drawer themeColor" @click="showANDhide">
                <div style="width: 5px;height: 25px;background:#fff;"></div>
              </div>
            </div>
          </el-aside> -->
          <el-main>
            <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="tabclick">
              <el-tab-pane
                v-for="(item, index) in editableTabs"
                :key="index"
                :label="item.title"
                :name="item.name">
                <keep-alive style="overflow-y: auto">
                  <router-view></router-view>
                </keep-alive>
              </el-tab-pane>
            </el-tabs>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
    <!-- S 二维码 -->
    <!-- <div v-show="isQRcard"
         style="display:flex;flex-direction:column;width: 600px;height: 400px;position: absolute;z-index: 999;background-color: #FFFFFF;left: 30%;top: 30%;border: 3px solid #2180d1;border-radius: 5px">
      <div style="text-align: center;border-bottom: 0.5px solid #CCCCCC;width: 100%;padding: 10px 0px;">
        <span style="color: black;font-weight: bold;">安卓手机端下载</span>
        <span style="float: right;cursor: pointer;margin-right:10px" @click="QRcareClose">关闭</span>
      </div>
      <div style="display: flex;justify-content: center;align-items: center">
        <img src="">
      </div>
      <span style="color:red;font-weight:bold;font-size:18px;">请务必使用手机浏览器或手机QQ扫码下载，不要用微信。</br>APP仅支持Android系统手机，不支持苹果手机。</br>该二维码禁止拍照外传！！！</span>
    </div> -->
    <!-- E 二维码 -->


  </el-container>


</template>
<script>
  import Header from "../components/header.vue";

  export default {
    data() {
      return {
        socket: '',
        socketPath: this.GLOBAL.SOCKET_URL + '?token=' + window.localStorage.getItem(this.GLOBAL.USER_TOKEN) + '&from=web',
        lockReconnect: false, //是否真正建立连接
        timeout: 280 * 1000, //30秒一次心跳
        timeoutObj: null, //心跳心跳倒计时
        serverTimeoutObj: null, //心跳倒计时
        timeoutnum: null, //断开 重连倒计时

        webLoginList: [],
        appLoginList: [],
        defaultProps: {
          children: "children",
          label: "label"
        },
        showmenu: true,
        isShowChat: false,
        loginActive: "weblogin",
        isQRcard: false,
        menuListFirst: [],
        menuListSecond: [],
        editableTabsValue: "/home",
        editableTabs: [],
        tabIndex: 1,
        asideStyle: 'width:200px;',
        left1: 6,
        left2: 24,
        sendText: '',
        leftMenu: [
          {
            icon: "iconfont icon-menu-open",
            name: "菜单",
            title: "菜单",
            url: "#",
            sort: 1
          },
          {
            icon: "iconfont icon-yonghuzaixian",
            name: "在线人员",
            title: "在线人员",
            url: "online",
            sort: 8
          }
        ],
        hiddenMenuId: 0,
        isShowOnline: false,

      };
    },
    created() {
      var menu;
      var menuStr = window.localStorage.getItem(this.GLOBAL.USER_MENU);
      var hiddenMenuStr = "";
      var hiddenMenuList = [];
      if (menuStr != '' && menuStr != null) {
        menu = JSON.parse(menuStr);
        for (var i = 0; i < menu.length; i++) {
          if (menu[i].url == '/addressBook') {
            // 是否包含通讯录
            this.leftMenu.push({
              icon: "iconfont icon-phonebook",
              name: "通讯录",
              title: menu[i].name,
              url: menu[i].url,
              sort: 7,
            })
          } else if (menu[i].url == '/newWork') {
            // 是否包含新建工作
            this.leftMenu.push({
              icon: "iconfont icon-xinjian",
              name: "新建",
              title: menu[i].name,
              url: menu[i].url,
              sort: 2
            })
          } else if (menu[i].url == '/myWork') {
            // 是否包含待办工作
            this.leftMenu.push({
              icon: "iconfont icon-daiban2",
              name: "待办",
              title: menu[i].name,
              url: menu[i].url,
              sort: 3
            })
          } else if (menu[i].url == '/historyWork') {
            // 是否包含已办
            this.leftMenu.push({
              icon: "iconfont icon-yibanshixiang",
              name: "已办",
              title: menu[i].name,
              url: menu[i].url,
              sort: 4
            })
          }
          // else if(menu[i].url == '/mail'){
          //   // 是否包含通知
          //   this.leftMenu.push({
          //     icon: "iconfont icon-youjian",
          //     name: "通知",
          //     title: menu[i].name,
          //     url: menu[i].url,
          //     sort: 6
          //   })
          // }
          // else if(menu[i].url == '/notice'){
          // 是否包含公告
          //this.leftMenu.push({
          //icon: "iconfont icon-gonggao8",
          //name: "公告",
          //title: menu[i].name,
          //url: menu[i].url,
          //sort: 7
          //})}
          else if (menu[i].url == '/document') {
            // 是否包含文档库
            this.leftMenu.push({
              icon: "iconfont icon-danganhe",
              name: "文档库",
              title: menu[i].name,
              url: menu[i].url,
              sort: 5
            })
          }

          if (menu[i].isShow == 1) {
            if (menu[i].level == 1) {
              this.menuListFirst.push(menu[i]);
            } else if (menu[i].level == 2) {
              this.menuListSecond.push(menu[i]);
            }
          } else {
            if (menu[i].url != '#') {
              hiddenMenuList.push(menu[i].url)
            }
          }
        }

        if (hiddenMenuList.length > 0) {
          hiddenMenuStr = hiddenMenuList.join(',');
        }
        // this.socketInit();
        this.addTab('主页', '/home');
        // var currentUrl = window.location.href;
        // if(currentUrl.split('#')[1] == "/"){
        //   this.activeIndex = "/home";
        // }else{
        //   this.activeIndex = currentUrl.split('#')[1];
        // }
      }
      this.$root.eventHub.$on(this.GLOBAL.MENU_EVENT, this.receiveTabs);
    },
    components: {
      Header
    },
    destroyed: function () {
      this.$root.eventHub.$off(this.GLOBAL.MENU_EVENT);
    },
    mounted: function () {
      // this.leftMenuActive(0);
    },
    methods: {
      closeSocket: function () {
        this.lockReconnect = true;
        this.timeoutObj = null;
        this.serverTimeoutObj = null;
        this.timeoutnum = null;
        this.socket.close();
        // this.socket = '';
      },
      socketInit: function () {
        if (typeof(WebSocket) === "undefined") {
          console.error("您的浏览器不支持socket")
        } else {
          // 实例化socket
          this.socket = new WebSocket(this.socketPath)
          // 监听socket连接
          this.socket.onopen = this.socketOpen
          // 监听socket错误信息
          this.socket.onerror = this.socketError
          // 监听socket消息
          this.socket.onmessage = this.socketGetMessage
          // 监听socket消息
          this.socket.onclose = this.socketClose
        }
      },
      socketOpen: function () {
        console.log("socket连接成功")
        this.start();
        // this.socketSend(JSON.stringify({
        //   from: 8,
        //   to: 1,
        //   content: 'aaaaaa'
        // }))
      },
      socketError: function () {
        console.error("连接错误")
        this.reconnect();
      },
      socketGetMessage: function (msg) {
        if (msg != '' && msg != null & msg != undefined) {
          let messageBody = JSON.parse(msg.data)
          if (messageBody.type == 'work') {
            // 系统提示消息
            this.$notify.info({
              title: '您有一项新工作需要处理',
              message: messageBody.content,
              dangerouslyUseHTMLString: true,
              type: 'warning',
              duration: 0
            });
          } else if (messageBody.type == 'mail') {
            this.$notify.info({
              title: '您有一条新通知需要查收',
              message: messageBody.content,
              dangerouslyUseHTMLString: true,
              type: 'warning',
              duration: 0
            });
          } else {
            // 聊天
          }
        }
        this.reset();
      },
      socketSend: function (params) {
        this.socket.send(JSON.stringify(params))
      },
      socketClose: function () {
        console.log("socket已经关闭")
        this.reconnect();
      },
      reconnect() {
        //重新连接
        var that = this;
        if (that.lockReconnect) {
          return;
        }
        that.lockReconnect = true;
        //没连接上会一直重连，设置延迟避免请求过多
        that.timeoutnum && clearTimeout(that.timeoutnum);
        that.timeoutnum = setTimeout(function() {
          //新连接
          that.socketInit();
          that.lockReconnect = false;
        }, 5000);
      },
      start() {
        //开启心跳
        var userId = this.CommonUtil.getUserInfo().userId;
        var self = this;

        self.timeoutObj && clearTimeout(self.timeoutObj);
        self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
        self.timeoutObj = setTimeout(function() {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          if (self.socket.readyState == 1) {
            //如果连接正常
            self.socketSend({
              to: userId,
              from: userId,
              type: 'heartCheck',
            });
          } else {
            //否则重连
            self.reconnect();
          }
          self.serverTimeoutObj = setTimeout(function() {
            //超时关闭
            self.socket.close();
          }, self.timeout);
        }, self.timeout);
      },
      reset() {
        //重置心跳
        var that = this;
        //清除时间
        clearTimeout(that.timeoutObj);
        clearTimeout(that.serverTimeoutObj);
        //重启心跳
        that.start();
      },



      chatWith: function (data) {
        return false;
        if (this.StringUtil.startWith(data.id, "U-")) {
          // console.log(this.chatPerson)
          // console.log(this.chatPerson.hasOwnProperty(data.value))
          if (!this.chatPerson.hasOwnProperty(data.value)) {
            this.chatPerson[data.value] = data.label
          }
          // for(var i in this.chatPerson){
          //   console.log(this.chatPerson[i])
          // }
          this.isShowChat = true;
        }
      },
      renderContent(h, {node, data, store}) {
        var label = node.label;
        if (data.parentId == "D-0") {
          return (
            <span class = "custom-tree-node" ><i class = "el-icon-s-home" > </i> <span style = "margin-left:5px;" >{node.label}</span></span>
          );
        } else if (data.id.indexOf('D-') > -1) {
          return (
            <span class = "custom-tree-node" ><i class = "el-icon-office-building"></i> <span style = "margin-left:5px;">{node.label}</span></span>
          )
        } else {
          return (
            <span class = "custom-tree-node"><i class = "el-icon-user-solid"></i><span style = "margin-left:5px;" >{node.label}</span></span>
          );
        }
      },
      receiveTabs(val) {
        this.addTab(val.name, val.url)
      },
      showANDhide() {
        this.showmenu = !this.showmenu;
        if (this.showmenu) {
          this.left1 = 6;
          this.left2 = 18;
          this.asideStyle = 'width:240px;';
        } else {
          this.left1 = 24;
          this.left2 = 0;
          this.asideStyle = 'width:60px;';
        }
      },
      leftMenuActive(item, index) {
        var arg = $("#leftMenu").children();
        for (var i = 0; i < arg.length; i++) {
          $(arg[i]).removeClass("leftMenuActive");
        }
        $(arg[index]).addClass("leftMenuActive");

        var _self = this;
        if (item.url == '#') {
          this.isShowOnline = false;
        } else if (item.url == 'online') {
          this.$axios.get("/user/getOnlineAllUser").then(res => {
            _self.webLoginList = res.data['web'];
            _self.appLoginList = res.data['app'];
            _self.isShowOnline = true;
          });
        } else {
          this.$root.eventHub.$emit(this.GLOBAL.MENU_EVENT, {name: item.title, url: item.url});
        }

      },
      addTab(name, url) {
        var sameIndex = 0;
        for (var i = 0; i < this.editableTabs.length; i++) {
          if (this.editableTabs[i].name == url) {
            sameIndex = 1;
            break;
          }
        }
        if (sameIndex == 0) {
          this.editableTabs.push({
            title: name,
            name: url,
            content: '<router-view name="' + url + '"/>'
          });
        }
        this.$router.push(url);
        this.editableTabsValue = url;
      },

      // clickTab(targetName) {
      // },
      tabclick(tab) {
        this.$router.push(tab.name);
        this.editableTabsValue = tab.name;
      },
      removeTab(targetName) {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }
        this.editableTabsValue = activeName;
        this.$router.push(activeName);
        this.editableTabs = tabs.filter(tab => tab.name !== targetName);
      },
      handleSelect(key, keyPath) {
        var tempList = key.split(',');
        // this.$router.push(key);
        this.addTab(tempList[1], tempList[0]);
        // this.$emit('selectmenu',{"name":tab.name,"value":key});
        // this.menuListSecond.forEach((tab, index) => {
        //   if (key == tab.url) {
        //     this.$emit("selectmenu", { name: tab.name, value: key });
        //   }
        // });
      },
      helpDoc() {
        window.localStorage.setItem(this.GLOBAL.VIEW_FILE, JSON.stringify({
          title: "帮助手册",
          downloadUrl: '../browser/help.pdf',
        }));
        window.open('./static/html/pdf.html');
      },
      showQRcard() {
        this.isQRcard = true;
      },
      QRcareClose(){
        this.isQRcard = false;
      },
    }
  };
</script>
<style scope>
  .content {
    overflow: hidden;
    height: 100vh;
    background-color: white;
  }

  .el-dialog {
    margin-top: 5vh !important
  }

  .leftMenu {
    color: rgba(201, 201, 201, 0.7);
  }

  .leftMenu:hover {
    color: white;
    cursor: pointer;
  }

  .leftMenuActive {
    color: #ffffff;
  }

  .menumb {
    margin-bottom: 15px;
  }

  .Drawer {
    width: 10px;
    height: 50px;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .el-submenu .el-menu-item {
    min-width: 0;
  }

  .el-menu {
    border-right: solid 1px #e6e6e6;
    list-style: none;
    position: relative;
    margin: 0;
    padding-left: 0;
    background-color: #FFF;
    text-align: left;
  }

  .el-menu-item {
    font-size: 14px;
    color: #303133;
    padding: 0 8px !important;
    cursor: pointer;
    -webkit-transition: border-color .3s, background-color .3s, color .3s;
    transition: border-color .3s, background-color .3s, color .3s;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-menu-item.is-active {
    color: #409EFF;
    background-color: #ecf5ff;
  }

  .el-submenu__title {
    font-size: 14px;
    color: #303133;
    padding: 0 8px !important;
    cursor: pointer;
    -webkit-transition: border-color .3s, background-color .3s, color .3s;
    transition: border-color .3s, background-color .3s, color .3s;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-submenu .el-menu-item {
    height: 50px;
    line-height: 50px;
    padding: 0 0 0 40px !important;
  }

  .el-table th {
    background-color: #ecf5ff;
    cursor: pointer;
  }

  .personItem:hover {
    cursor: pointer;
    background-color: #fff;
    color: black !important;
  }

  /*滚动条样式*/
  #hiddenMenu::-webkit-scrollbar {
    width: 2px;
  }

  #hiddenMenu::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(64, 158, 255, 0.8);
  }

  #hiddenMenu::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .el-main {
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
    overflow: auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px;
  }

  .el-header {
    padding: 0 0px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }

  /* .el-textarea__inner {
    display: block;
    resize: vertical;
    line-height: 1.5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    font-size: inherit;
    color: #606266;
    background-color: #FFF;
    background-image: none;
    border: none;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  } */

</style>



// WEBPACK FOOTER //
// src/components/index.vue